import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

import 'amfe-flexible'

// 加载抽奖插件
import VueLuckyCanvas from '@lucky-canvas/vue'
Vue.use(VueLuckyCanvas)

// 引入 Vconsole
// import Vconsole from 'vconsole'
// // 所有环境均使用
// new Vconsole()

// 在 development 环境才使用
// process.env.NODE_ENV === 'development' ? new Vconsole : ''

//引入vant组件
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

//引入iconfont
import '@/assets/icon/myIcon/iconfont.css'
import '@/assets/icon/myIcon/iconfont.js'

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
